const getLocalization = (lang) => {
  let localization;
  switch (lang) {
    case "nl":
      localization = {
        days: [
          "Zondag",
          "Maandag",
          "Dinsdag",
          "Woensdag",
          "Donderdag",
          "Vrijdag",
          "Zaterdag",
        ],
        daysShort: ["ZON", "MAA", "DIN", "WOE", "DON", "VRI", "ZAT"],
        fullTime: "AFGELOPEN",
        halfTime: "RUST",
        months: [
          "Januari",
          "Februari",
          "Maart",
          "April",
          "Mei",
          "Juni",
          "Juli",
          "Augustus",
          "September",
          "Oktober",
          "November",
          "December",
        ],
        monthsShort: [
          "JAN",
          "FEB",
          "MAA",
          "APR",
          "MEI",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OKT",
          "NOV",
          "DEC",
        ],
        zoneWarning: "App kan niet worden weergegeven in deze zone",
        upcoming: "Volgende",
      };
      break;
    case "fr":
      localization = {
        days: [
          "Dimanche",
          "Lundi",
          "Mardi",
          "Mercredi",
          "Jeudi",
          "Vendredi",
          "Samedi",
        ],
        daysShort: ["DIM", "LUN", "MAR", "MER", "JEU", "VEN", "SAM"],
        fullTime: "COMPLÉTER",
        halfTime: "MI-TEMPS",
        months: [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août",
          "Septembre",
          "Octobre",
          "Novembre",
          "Décembre",
        ],
        monthsShort: [
          "JAN",
          "FÉV",
          "MAR",
          "AVR",
          "MAI",
          "JUIN",
          "JUIL",
          "AOÛ",
          "SEP",
          "OCT",
          "NOV",
          "DÉC",
        ],
        zoneWarning: "App ne peut pas être affichée dans cette zone",
        upcoming: "Prochain",
      };
      break;
    case "de":
      localization = {
        days: [
          "Sonntag",
          "Montag",
          "Dienstag",
          "Mittwoch",
          "Donnerstag",
          "Freitag",
          "Samstag",
        ],
        daysShort: ["SON", "MON", "DIE", "MIT", "DON", "FRE", "SAM"],
        fullTime: "FERTIG",
        halfTime: "HALBZEIT",
        months: [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember",
        ],
        monthsShort: [
          "JAN",
          "FEB",
          "MÄR",
          "APR",
          "MAI",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OKT",
          "NOV",
          "DEZ",
        ],
        zoneWarning: "App kann nicht in dieser zone angezeigt werden",
        upcoming: "Kommend",
      };
      break;
    case "es":
      localization = {
        days: [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado",
        ],
        daysShort: ["DOM", "LUN", "MAR", "MIÉ", "JUE", "VIE", "SÁB"],
        fullTime: "DISPUESTO",
        halfTime: "PAUSA",
        months: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        monthsShort: [
          "ENE",
          "FEB",
          "MAR",
          "ABR",
          "MAY",
          "JUN",
          "JUL",
          "AGO",
          "SEP",
          "OCT",
          "NOV",
          "DIC",
        ],
        zoneWarning: "La aplicación no puede mostrarse en esta zona",
        upcoming: "Próximo",
      };
      break;
    default:
      localization = {
        days: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        daysShort: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
        fullTime: "Full Time",
        halfTime: "Half Time",
        months: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        monthsShort: [
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC",
        ],
        zoneWarning: "App cannot be supported in this zone or layout.",
        upcoming: "Upcoming",
      };
  }

  return localization;
};

export default getLocalization;
